import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import * as cls from "./modalCaptcha.module.scss";
import { useState } from "react";
import Loader from "../loader/Loader";
import { Button } from "../../../personal-studio-components/form";

export default function ModalCaptcha(props) {
  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpen(false);
    // dispatch(currentNotificationIndexAction());
    props.setCaptchaData("");
  };

  return (
    <Dialog
      open={props.open}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: cls.dialog_paper }}
      hideBackdrop
    >
      <DialogTitle
        sx={{ margin: "15px 0 !important", padding: "0 24px" }}
        id="responsive-dialog-title"
      >
        Введите текст из картинки
      </DialogTitle>
      <DialogContent>
        {/* <DialogContentText> */}
        <div
          className={cls.captchaContainer}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className={cls.imgContainer}>
            {props.captchaUrl && !props.isLoading ? (
              <img src={props.captchaUrl} />
            ) : (
              <Loader
                sx={{
                  width: "calc(100% - 10px)",
                  height: "100%",
                  margin: "auto",
                  marginTop: "30px",
                }}
              />
            )}
          </div>
          <div className={cls.errorMessage}>{props.errorMessage}</div>
          <input
            className={cls.input}
            placeholder="Введите текст из картинки"
            value={props.captchaData}
            onChange={(e) => {
              props.setCaptchaData(e.target.value);
            }}
          />
        </div>
        {/* </DialogContentText> */}
      </DialogContent>
      <div className={cls.dialogActions}>
        <div>
          <DialogActions classes={{ paper: cls.dialogContnent }}>
            <Button
              onClick={async () => {
                await props.handleAgreementWithCaptcha(
                  props.message,
                  props.comment
                );
                // handleClose();
              }}
              disabled={!props.captchaData}
            >
              Подтвердить
            </Button>
            <Button type="primary" onClick={handleClose}>
              Закрыть
            </Button>
          </DialogActions>
        </div>
      </div>
    </Dialog>
  );
}
